import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail?.msg || detail);
}

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export function fmtTimeCT(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago", hour: "numeric", minute: "2-digit",
    }).format(new Date(iso));
  } catch { return ""; }
}

export function fmtDateCT(iso, withDay = true) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago",
      ...(withDay ? { weekday: "short" } : {}),
      month: "short", day: "numeric",
    }).format(new Date(iso));
  } catch { return ""; }
}

export default api;
